// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'temp-solid';

export const Component = () => (
  <path d='M14.896 16.47h-.048V2.006c0-.239-.096-.479-.287-.718A.946.946 0 0 0 13.89 1h-2.97a.946.946 0 0 0-.67.288c-.192.24-.288.478-.288.718V16.47C8.67 17.38 8 18.577 8 20.157c0 1.198.431 2.25 1.293 3.113a4.267 4.267 0 0 0 3.113 1.293c1.198 0 2.251-.431 3.114-1.293a4.267 4.267 0 0 0 1.293-3.113c0-1.58-.623-2.778-1.916-3.687Zm-.766 5.411a2.352 2.352 0 0 1-1.725.719 2.35 2.35 0 0 1-1.724-.719 2.352 2.352 0 0 1-.718-1.724c0-.623.19-1.15.575-1.58.335-.432.814-.67 1.34-.815l.048-7.902h.958v7.902c.575.144 1.053.383 1.436.815.335.43.527.957.527 1.58 0 .67-.24 1.245-.719 1.724h.002Z' />
);

export const viewBox = '0 0 25 25';
